import React from 'react';
import styles from './GroupCellRenderer.module.css';
import PropTypes from 'prop-types';


const LevelCell = ({data, value}) => {
  //const {levelLabel} = data;
  return (
    <div className={styles.root}>
      <div className={styles.val}>
        {value}
      </div>

    </div>
  );
};
const GroupCellRenderer = (props) => {

    return <LevelCell {...props}/>;
  
};


GroupCellRenderer.prototype = {
  data: PropTypes.object.isRequired, //supplied by ag-grid
};

export default GroupCellRenderer;
